import { DeleteUserLevelDto, GetUserLevelDto, InitializeUserLevelDto, MessageResponseDto, QuotaSystemApiFp, RegistrationControllerGet200Response } from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseQuotaSystemModel = RegistrationControllerGet200Response;
export type InitializeUserLevelModel = InitializeUserLevelDto;
export type MutateResponsequotaSystemModel = MessageResponseDto;
export type DeleteUserLevelModel = DeleteUserLevelDto;
export type GetUserLevelModel = GetUserLevelDto;

export const apiQuotaSystemFp = QuotaSystemApiFp(apiConfig);
export const initializeUserQuotaSystemController =
  apiQuotaSystemFp.quotaSystemControllerInitializeUser;
export const getUserLevelQuotaSystemController =
  apiQuotaSystemFp.quotaSystemControllerGetUserLevel;
export const recalculateUserLevelQuotaSystemController =
  apiQuotaSystemFp.quotaSystemControllerRecalculateUserLevel;
export const runBatchAnnualEvalQuotaSystemController =
  apiQuotaSystemFp.quotaSystemControllerRunBatchAnnualEvaluation;

export const QueryKeyQuotaSystem = QueryKey.QuotaSystem;
